/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { AuthService } from '../../../../service/auth.service';
import { FeatureFlagsService } from 'src/app/shared/services/customer-api/feature-flags.service';
import { PortfolioApiService } from 'src/app/shared/services/customer-api/portfolio-api.service';
import { EntityInfoService } from 'src/app/shared/services/metadata-api/entity-info.service';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { parseIsins } from '../portfolio-index/bulk-add';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-portfolio-import',
  templateUrl: './portfolio-import.component.html',
  styleUrls: ['./portfolio-import.component.scss'],
})
export class PortfolioImportComponent {
  import: string;
  ready: boolean;
  tooltip =
    'Please paste your list of ISINs here, they can be copied directly from an excel column or you can paste them manually, separated by a space or break Eg. US0378331005 DE4778931005';
  isins: any;
  nones: any;
  namefolio: UntypedFormControl;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    public auth: AuthService,
    public featureFlagsService: FeatureFlagsService,
    private portfolioApi: PortfolioApiService,
    private entityInfoService: EntityInfoService,
    public snackBar: MatSnackBar,
  ) {
    this.namefolio = new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(3),
    ]);
  }

  iParse() {
    this.isins = [];
    this.nones = [];
    this.entityInfoService
      .isinParse(parseIsins(this.import))
      .subscribe((result) => {
        for (const property in result) {
          const entity = result[property];
          if (entity) {
            this.isins.push(entity);
          } else {
            this.nones.push(property);
          }
        }
        this.ready = true;
      });
  }

  iSubmit() {
    if (!this.namefolio.valid) return;
    const limits = this.featureFlagsService.featureFlags;
    if (
      this.portfolioApi.portfolios &&
      this.portfolioApi.portfolios.length + 1 > limits.portfoliosLimit
    ) {
      this.snackBar.open(
        'Number of portfolios is limited to ' + limits.portfoliosLimit + '.',
        'OK',
        { duration: 5000 },
      );
      return;
    }
    this.portfolioApi.newFolio(this.namefolio.value).subscribe((result) => {
      if (this.isins && this.isins.length > limits.entitiesPerPortfoliosLimit) {
        this.snackBar.open(
          'Number of entities per portfolio is limited to ' +
            limits.entitiesPerPortfoliosLimit +
            '.',
          'OK',
          { duration: 5000 },
        );
        return;
      }
      this.portfolioApi
        .addEntitiesToPortfolios(
          this.isins.map((item) => item.compound_key),
          [result.id],
        )
        .subscribe(() => {
          this.dialog.closeAll();
          this.router.navigate([], {
            queryParams: { id: result.id, update: Math.random() },
            queryParamsHandling: 'merge',
          });
        });
    });
  }
}
